var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-app-bar',{attrs:{"app":"","clipped-left":"","height":"50"}},[_c('v-toolbar-title',[_vm._v("Lezení")])],1),_c('v-content',[_c('MapyCzMap')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }